export default "__VITE_ASSET__BLG2cmNY__"